import React from "react";
import { TranslationObject } from "../../models/translationModal";
import Modal from "../Modal";

interface Props {
  entities?: TranslationObject;
  visible: boolean;
  changeVisible: (value: boolean) => void;
}

const DraftSpecialistModal: React.FC<Props> = ({ entities, visible, changeVisible }) => {
  const closeModal = () => {
    changeVisible(false);
  }

  return (
    <Modal
      visible={visible}
      onClose={closeModal}
      description={entities?.profile_draft_thank?.value}
    >
        <div className="modal__content-buttons">
            <button
                className="btn modal__content-button btn--bg-green"
                type="button"
                onClick={closeModal}
            >
                {entities?.common_continue_button?.value}
            </button>
        </div>
    </Modal>
  )
}

export default DraftSpecialistModal;